<template>
    <div :class="isMobile?'swiperBoxB':'swiperBox'">
        <el-carousel :height="isMobile?'':'400px'" arrow="never" ref="carousel" :interval="6000">
            <el-carousel-item v-for="(item,index) in swiperList" :key="index">
                <div class="swiperImg" :class="item.IsWeblb==1?'':'curp'" @click="lookInfo(item.NewsGuid,item.IsWeblb)">
                    <img :src="item.FileSavePath" alt="" style="width: 100%;">
                    <div class="bgBox">
                        <p class="swiperT overh">{{item.Title}}</p>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                swiperList:[],
            }
        },
        methods:{
            //获取列表数据
            getListData(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataThree',
                    method: 'get',
                    data:{
                        cataCode:106101,
                        pageSize:3
                    }
                }).then((data) => {
                    this.swiperList = data.Data
                })
            },



            // 查看详情
            lookInfo(id,type){
                if(type==1){
                    return
                }
                this.$router.push({
                    path:'/notice/info?id='+id+'&type=106101'
                })
            }
        },
        mounted(){
            this.getListData()
        }
    }
</script>

<style>
    .swiperBox{
        width: 680px;
        height: 400px;
        background-color: #fff;
        overflow: hidden;
        border-radius: 10px;
        position: relative;
    }
    .swiperBoxB{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        border-radius: 10px;
        position: relative;
    }
    .swiperImg{
        height: 100%;
    }
    .swiperImg img{
        height: 100%;
    }
    .bgBox{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 40px;
        z-index: 1000;
        background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, #000000 100%);
    }
    .swiperT{
        position: absolute;
        left: 2%;
        bottom: 10px;
        z-index: 1000;
        color: #fff;
        max-width: 80%;
    }
    .el-carousel__indicators--horizontal{
        right: 1%;
        transform: translateX(1%);
        text-align: right;
    }
    .el-carousel__indicators--horizontal .is-active .el-carousel__button{
        background-color: #2D7CF2;
    }
    .el-carousel__button{
        width: 8px;
        height: 8px;
        background-color: #D8D8D8;
        border-radius: 50%;
    }
    .el-carousel__item.is-animating {
        -webkit-transition: -webkit-transform 2s ease-in-out;
        transition: -webkit-transform 2s ease-in-out;
        transition: transform 2s ease-in-out;
        transition: transform 2s ease-in-out,-webkit-transform 2s ease-in-out;
    }
</style>